export default __webpack_public_path__ + "static/media/AgentWebiste4.d185820a.png";